// Пользовательское соглашение (оферта для гостя заведения).
// Открывается со страницы входа по ссылке из согласия пользователя.

import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-full px-6 pt-6 pb-10 max-w-2xl mx-auto">
      <button
        className="text-slate-500 text-sm flex items-center gap-1 self-start -ml-1 mb-4"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={16} /> Назад
      </button>

      <h1 className="text-2xl font-semibold mb-2">Пользовательское соглашение</h1>
      <p className="text-xs text-slate-500 mb-6">Редакция от {new Date().getFullYear()} года</p>

      <div className="prose prose-slate max-w-none text-[14px] leading-relaxed space-y-4">
        <p>
          Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между
          заведением общественного питания (далее — «Заведение») и физическим лицом (далее —
          «Пользователь») по поводу использования сервиса электронного меню и оформления заказов
          (далее — «Сервис»).
        </p>

        <h2 className="text-base font-semibold mt-4">1. Общие положения</h2>
        <p>
          Соглашение является публичной офертой в соответствии со ст. 437 ГК РФ. Регистрация
          и использование Сервиса означают полное и безоговорочное принятие Пользователем условий
          настоящего Соглашения.
        </p>

        <h2 className="text-base font-semibold mt-4">2. Предмет</h2>
        <p>
          Заведение предоставляет Пользователю доступ к Сервису для ознакомления с меню, формирования
          заказа и направления его в Заведение. Договор розничной купли-продажи считается заключённым
          с момента подтверждения заказа Заведением (ст. 493 ГК РФ).
        </p>

        <h2 className="text-base font-semibold mt-4">3. Регистрация</h2>
        <p>
          Для оформления заказа Пользователь проходит процедуру подтверждения по номеру телефона или
          адресу электронной почты (одноразовый код). Пользователь подтверждает, что указанные им
          данные достоверны и принадлежат ему.
        </p>

        <h2 className="text-base font-semibold mt-4">4. Оплата и доставка</h2>
        <p>
          Стоимость блюд указана в рублях РФ и включает НДС, если иное не указано отдельно. Условия
          оплаты и доставки определяются Заведением и отображаются в интерфейсе Сервиса перед
          оформлением заказа.
        </p>

        <h2 className="text-base font-semibold mt-4">5. Права и обязанности</h2>
        <p>
          Пользователь обязуется не использовать Сервис для действий, нарушающих законодательство РФ,
          права третьих лиц или работу Сервиса. Заведение вправе отказать в исполнении заказа в случае
          выявления недостоверных данных или нарушения условий Соглашения.
        </p>

        <h2 className="text-base font-semibold mt-4">6. Ответственность</h2>
        <p>
          Стороны несут ответственность в соответствии с законодательством РФ, в том числе Законом
          «О защите прав потребителей» от 07.02.1992 № 2300-1.
        </p>

        <h2 className="text-base font-semibold mt-4">7. Персональные данные</h2>
        <p>
          Обработка персональных данных Пользователя осуществляется в соответствии с Политикой
          обработки персональных данных и Федеральным законом от 27.07.2006 № 152-ФЗ.
        </p>

        <h2 className="text-base font-semibold mt-4">8. Применимое право</h2>
        <p>
          К настоящему Соглашению применяется законодательство Российской Федерации. Все споры
          разрешаются в порядке, установленном законодательством РФ, по месту нахождения Заведения.
        </p>
      </div>
    </div>
  );
}
